import {
  BlockFooter,
  BlockHeader,
  Container,
  ContentWrapper,
} from 'page/Application/VisitedPage/component/LayoutDefault/styled';

const LayoutDefault = ({ children, minHeight }) => {
  return (
    <ContentWrapper style={{ minHeight: minHeight }}>
      <Container>
        <BlockHeader />
        {children}
        <BlockFooter />
      </Container>
    </ContentWrapper>
  );
};

export default LayoutDefault;
